import Icon from '../components/Icon.vue'

Icon.register({
  microscope: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M160 320H172V336C172 344.8 179.2 352 188 352H228C236.8 352 244 344.8 244 336V320H256C273.7 320 288 305.7 288 288V64C288 46.3 273.7 32 256 32V16C256 7.2 248.8 0 240 0H176C167.2 0 160 7.2 160 16V32C142.3 32 128 46.3 128 64V288C128 305.7 142.3 320 160 320zM464 448H462.7C493.2 414 512 369.2 512 320 512 214.1 425.9 128 320 128V192C390.6 192 448 249.4 448 320S390.6 448 320 448H48C21.5 448 0 469.5 0 496 0 504.8 7.2 512 16 512H496C504.8 512 512 504.8 512 496 512 469.5 490.5 448 464 448zM104 416H312C316.4 416 320 412.4 320 408V392C320 387.6 316.4 384 312 384H104C99.6 384 96 387.6 96 392V408C96 412.4 99.6 416 104 416z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/microscope.js
// module id = NljF
// module chunks = 144